import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Avatar,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import AugrealImage from "../../images/augreal.jpg";
import Telecom from "../../images/telecom.jpg";
import TechnicalImage from "../../images/techical.jpg";


const LatestNews = () => {
  const navigate = useNavigate();

  const blogPosts = [
    {
      id: 1,
      category: "Infrastructure",
      title: "All About Telecom OSS",
      image: Telecom,
      author: "admin",
      date: "Dec 6, 2025",
    },
    {
      id: 2,
      category: "Application Development",
      title: "Augmented Reality In Everyday Applications",
      image: AugrealImage,
      author: "admin",
      date: "Dec 5, 2025",
    },
    {
      id: 3,
      category: "Recruiting",
      title: "Tips for creating a killer technical resume",
      image: TechnicalImage,
      author: "admin",
      date: "Dec 4, 2025",
    },
  ];

  return (
    <Box sx={{ py: { xs: 8, md: 10 }, bgcolor: "#f5f7fa" }}>
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              mb: 2,
              color: "#2a5298",
              fontSize: { xs: "0.95rem", md: "1.25rem" },
            }}
          >
            Latest News
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 900,
              fontSize: { xs: "1.8rem", md: "32px" },
              color: "#0D47A1",
            }}
          >
            Our insights and articles
          </Typography>
        </Box>

        {/* Blog Cards Grid */}
        <Grid container spacing={4} sx={{ mb: 6 }}>
          {blogPosts.map((post) => (
            <Grid item xs={12} md={4} key={post.id}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 2,
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 12px 24px rgba(0,0,0,0.12)",
                  },
                }}
              >
                {/* Image Section */}
                <CardMedia
                  component="img"
                  height="280"
                  image={post.image}
                  alt={post.title}
                  sx={{
                    objectFit: "cover",
                  }}
                />

                {/* Content Section */}
                <CardContent
                  sx={{
                    p: { xs: 2, md: 2.5 },
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Category Tag */}
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#2a5298",
                      fontWeight: 700,
                      // textTransform: "uppercase",
                      letterSpacing: 0.5,
                      fontSize: { xs: "0.75rem", md: "0.9rem" },
                      mb: 1.5,
                    }}
                  >
                    {post.category}
                  </Typography>

                  {/* Title */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 2,
                      color: "#0D47A1",
                      fontSize: { xs: "1.1rem", md: "1.35rem" },
                      lineHeight: 1.4,
                      flex: 1,
                    }}
                  >
                    {post.title}
                  </Typography>

                  {/* Author Section */}

                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Learn More Button */}
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate("/blog")}
            sx={{
              color: "#2a5298",
              borderColor: "#2a5298",
              fontWeight: 600,
              px: 4,
              py: 1.2,
              "&:hover": {
                bgcolor: "rgba(42, 82, 152, 0.04)",
                borderColor: "#1e3c72",
              },
            }}
          >
            Learn More
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default LatestNews;
